export default __webpack_public_path__ + "media/images/landing-1-550x420-e004ef76a74a45073c87c1b717e8be47.jpg";